import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import {MuiThemeProvider, createMuiTheme} from '@material-ui/core/styles'
import cyan from '@material-ui/core/colors/cyan'
import purple from '@material-ui/core/colors/purple'
import grey from '@material-ui/core/colors/grey'
import ReactGA from 'react-ga'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import './assets/css/styles.css'

const theme = createMuiTheme({
  palette: {
    primary: {
      light: cyan[100],
      main: cyan[800],
      dark: cyan[900],
      contrastText: 'white',
    },
    secondary: {
      light: purple[400],
      main: purple[800],
      dark: purple[800],
      contrastText: 'white',
    },
    grey: {
      light: grey[300],
      main: grey[600],
      dark: grey[800],
      contrastText: 'white',
    },
  },
})

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <App />
  </MuiThemeProvider>,
  document.getElementById('root'),
)
registerServiceWorker()

ReactGA.initialize('G-WZMJFZ5GPQ')
ReactGA.pageview(window.location.pathname + window.location.search)



// WEBPACK FOOTER //
// ./src/index.js